export const customersModule = "Customers";
export const salesOrdersModule = "SalesOrders";
export const salesOrdersv2Module = "SalesOrdersV2";
export const reconciliationv2Module = "ReconciliationV2";
export const ecommerceModule = "Ecommerce";
export const aiModule = "Ai";
